var map = {
	"./01-min.jpg": "0866",
	"./02-min.jpg": "7762",
	"./03-min.jpg": "9d99",
	"./04-min.jpg": "9bce",
	"./05-min.jpg": "0d5b",
	"./06-min.jpg": "8c04",
	"./07-min.jpg": "9959",
	"./08-min.jpg": "3a8c",
	"./09-min.jpg": "ce64",
	"./10-min.jpg": "f7a3",
	"./11-min.jpg": "e1f5",
	"./12-min.jpg": "bc39"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "13c2";